module.exports = __webpack_public_path__ + "assets/a2922c301b474c75ab02a59580aef0b5.mp3";